import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
const CustomModal = ({visibility,handleClose,children}) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };
  return (
 <>
 
 <Modal
 className='col-lg-11 mx-auto col-md-4 '
  open={visibility}
  onClose={handleClose}
  
>
  <Box sx={style} className="p-3 p-md-4">
{children}
  </Box>
</Modal>
 </>
  )
}

export default CustomModal